import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ExportSuspectedManipulationUseCaseInterface } from 'domain/usecases';

export class RemoteExportSuspectedManipulation
  implements ExportSuspectedManipulationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ExportSuspectedManipulationUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportSuspectedManipulationUseCaseInterface.Params,
  ): Promise<ExportSuspectedManipulationUseCaseInterface.Result> {
    const { type, ...request } = params;

    const requestUrl = generateUrl(`${this.url}/${type}`, { ...request });

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
